import React, { useState, useRef, useEffect, forwardRef } from 'react';
import { useNavigate, NavLink, useParams  } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import DatosCabezaFamilia from '../Caracterizacion/DatosCabezaFamilia.jsx';
import apiService from '../../Auth/apiService.jsx';
import DatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';
import MenuReincorporados from './MenuReincorporados.jsx';
import { useAuth } from '../../Auth/AuthContext.jsx';
import { es, id } from 'date-fns/locale';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';

import { FaCalendar } from 'react-icons/fa';

registerLocale('es', es);
setDefaultLocale('es');
import PropTypes from 'prop-types';

const CustomInput = forwardRef(({ value, onClick }, ref) => (
        <button
            type="button"
            className="custom-input"
            onClick={onClick}
            ref={ref}
            aria-label="Seleccionar fecha"
            style={{ display: 'flex', alignItems: 'center', border: 'none', background: 'none', padding: 0 }}
        >
            <input 
                value={value} 
                readOnly 
                className='widthCalendar' 
                style={{ 
                    pointerEvents: 'none',
                    background: '#fff',
                    border: '1px solid #ced4da',
                    padding: '6px 8px',
                    borderRadius: 4,
                    minWidth: 140,
                    marginRight: 8, 
                    }}
                />
            <FaCalendar size={20} color="black"/>
        </button>
        ));

CustomInput.propTypes = {
    value: PropTypes.string,
    onClick: PropTypes.func,
};
export default function Empleabilidadrei(){
    const hasRun = useRef(false);
    const { token, user, rol } = useAuth();
    const navigate = useNavigate();
    const [swalProps, setSwalProps] = useState({});
    const { idCabezaFamilia } = useParams();
    const [show, setShow] = useState(false);
    const showModal = () => setShow(true);
    const hideModal = () => setShow(false);
    const [barrios, setBarrios] = useState([]);
    const [cargo, setCargo] = useState('');
    const [bolsasEmpleo, setBolsasEmpleo] = useState([]);
    const [procesosEmpleabilidad, setProcesosEmpleabilidad] = useState([]);
    const [tiposTalleres, setTiposTalleres] = useState([]);
    const [tiposVinculacion, setTiposVinculacion] = useState([]);
    const [ingresosEconomicos, setIngresosEconomicos] = useState([]);
    const [estadosRemision, setEstadosRemision] = useState([]);
    const [estadoProcesoEmpleabilidad, setEstadoProcesoEmpleabilidad] = useState([]);
    const [integrantesdto, setIntegrantesdto] = useState([]);
    const [articulacionEmpleabilidad, setArticulacionEmpleabilidad] = useState([]);
    const [experienciasEmpleabilidad, setExperienciasEmpleabilidad] = useState([]);
    const [remisionLaboralEmpleabilidad, setRemisionLaboralEmpleabilidad] = useState([]);
    const [seguimientoEmpleabilidad, setSeguimientoEmpleabilidad] = useState([]);
    const [talleresEmpleabilidad, setTalleresEmpleabilidad] = useState([]);
    const [Cargando, setCargando] = useState(false);
    const [nuevoTaller, setNuevoTaller] = useState({
        id: null,
        intEmpleabilidadid: null,
        intIdtipotaller: '',
        datFechataller: null,
        strEntidadtaller: '',
    });
    const [nuevaExperiencia, setNuevaExperiencia] = useState({
        id: null,
        intEmpleabilidadid: null,
        strExperiencia: null,
        strTiempoexperiencia: '',
    });
    const [nuevoSeguimiento, setNuevoSeguimiento] = useState({
        id: null,
        intEmpleabilidadid: null,
        datFechaseguimiento: null,
        intEstadoactualproceso: '',
        strObservacionseguimiento: '',
    });
    const [nuevoRemision, setNuevoRemision] = useState({
        id: null,
        intEmpleabilidadid: null,
        bolRealizaremision: null,
        datFecharemision: null,
        strEmpresaremision: '',
        strCargoremision: '',
        intIdestadoremision: '',
    });
    const [nuevoArticulacion, setNuevoArticulacion] = useState({
        id: null,
        intEmpleabilidadid: null,
        intRemisionlaboralid: null,
        datFechaarticulacion: null,
        strNombreempresaarticulacion: '',
        strContactoempresaarticulacion: '',
        strTelefonoempresaarticulacion: '',
        strCorreoempresaarticulacion: '',
    });
    const [FormCabezaFamilia, setFormCabezaFamilia] = useState([]);
    const [CabezaFamiliaDatos, setCabezaFamiliaDatos] = useState({
        nombre: '',
        cab_idcabezafamilia: '',
        cab_direccion: '',
        telefono: '',
        cab_celular: '',
        cab_correoelectronico: '',
      });
    const {register, handleSubmit, control, setValue, reset, watch, getValues, formState: { errors }} = useForm({
        defaultValues: {
            articulacionEmpleabilidad: [],
            experienciasEmpleabilidad: [],
            remisionLaboralEmpleabilidad: [],
            seguimientoEmpleabilidad: [],
            talleresEmpleabilidad: [],
        }
      });
    
    const idEmpleabilidad = watch('id');
    const emptyEmpleabilidadFormValues = {
        id: null,
        usrId: user,
        cabIdcabezafamilia: idCabezaFamilia,
        strIdpersona: '',
        strCargo: '',
        strHabilidadcompetencia: '',
        strIntereslaboral: '',
        bolTienecertificados: '',
        bolParticipajornadaempleo: '',
        bolRegistrohojavidaq: '',
        intIdbolsaempleo: '',
        bolLogrovinculacionlaboral: '',
        datFechavinculacion: null,
        strEmpresavinculacion: '',
        strCargovinculacion: '',
        intIdtipovinculacion: '',
        intIdingresoseconomicos: '',
        strObservacion: '',
        articulacionEmpleabilidad: [],
        experienciasEmpleabilidad: [],
        remisionLaboralEmpleabilidad: [],
        seguimientoEmpleabilidad: [],
        talleresEmpleabilidad: [],
    };

    const onSubmit = async (data) => {
        setCargando(true);
        const url = '/reincorporados/guardarempleabilidad';
        try {
            const response = await apiService.post(url, data, token);
            if(response.status === 200){
               FormReset(null);
               ConsultarProcesosEmpleabilidadPersona();
               Mensaje('Guardar empleabilidad', JSON.stringify(response.data.message));
            }
        } catch (error) {
            if(error.status === 422){
                Mensaje('Guardar empleabilidad', JSON.stringify(error.response.data.errors));
            }else if(error.status === 409){
                Mensaje('Guardar empleabilidad', JSON.stringify(error.response.data));
            }
        } finally {
          setCargando(false);
        }
      };
   
    const setFormValuesFromCabezaFamilia = (cabezafamilia) => {
        if (cabezafamilia) {
            reset((prevValues) => ({
                ...prevValues,
                ...cabezafamilia,
                usrId: user,
                cabIdcabezafamilia: idCabezaFamilia,
            }));
        }
    };
    async function FormReset(datosEmpleabilidad){
        if (!datosEmpleabilidad) {
            reset(emptyEmpleabilidadFormValues);
            return;
        }
        reset({
            ...emptyEmpleabilidadFormValues,
            ...datosEmpleabilidad,
        });
        const fechaVinculacion = datosEmpleabilidad.datFechavinculacion.slice(0, 10)
        const fechaVinculacion2 = new Date(fechaVinculacion+'T12:00:00');
        setValue('datFechavinculacion', fechaVinculacion2);
    }
    // Helper to set array state or log error
    const setArrayStateOrError = (data, setter, label) => {
        if (Array.isArray(data)) {
            setter(data);
        } else {
            console.error(`Invalid data for ${label}:`, data);
        }
    };
    const ConsultarProcesosEmpleabilidadPersona = async () => {
        const url = '/reincorporados/consultarprocesosempleabilidadpersona';
        const obj = { idCabezaFamilia: idCabezaFamilia, usrRolid: rol, userId: user };
        try {
            setCargando(true);
            const response = await apiService.post(url, obj, token);
            const result = await response.data;
            setArrayStateOrError(result.procesosEmpleabilidad, setProcesosEmpleabilidad, 'procesosEmpleabilidad');
            
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    };
    useEffect(() => {
        if (!hasRun.current) {
            

            const fetchData = async () => {
                const url = '/reincorporados/crearformularioempleabilidad';
                const obj = { idCabezaFamilia: idCabezaFamilia, usrRolid: rol, userId: user };
                try {
                    setCargando(true);
                    const response = await apiService.post(url, obj, token);
                    const result = await response.data;
                    
                    setArrayStateOrError(result.bolsasEmpleo, setBolsasEmpleo, 'bolsasEmpleo');
                    setArrayStateOrError(result.procesosEmpleabilidad, setProcesosEmpleabilidad, 'procesosEmpleabilidad');
                    setArrayStateOrError(result.tiposTalleres, setTiposTalleres, 'tiposTalleres');
                    setArrayStateOrError(result.tiposVinculacion, setTiposVinculacion, 'tiposVinculacion');
                    setArrayStateOrError(result.ingresosEconomicos, setIngresosEconomicos, 'ingresosEconomicos');
                    setArrayStateOrError(result.estadosRemision, setEstadosRemision, 'estadosRemision');
                    setArrayStateOrError(result.integrantesdto, setIntegrantesdto, 'integrantesdto');
                    setArrayStateOrError(result.estadoProcesoEmpleabilidad, setEstadoProcesoEmpleabilidad, 'estadoProcesoEmpleabilidad');
                    
                    setCabezaFamiliaDatos(result.cabezafamilia);
                    setFormCabezaFamilia(result.cabezafamilia);
                    FormReset(null);
                } catch (error) {
                    console.error('Error fetching data:', error);
                } finally {
                    setCargando(false);
                }
            };
            fetchData();
            hasRun.current = true;
        }
    }, [idCabezaFamilia, setValue, user, reset, token]);
    useEffect(() => {
        if (barrios.length > 0 && FormCabezaFamilia?.cab_barrio) {
            setFormValuesFromCabezaFamilia(FormCabezaFamilia);
        }
    }, [barrios, FormCabezaFamilia]);
    
    const agregarTaller = () => {
        if (!nuevoTaller.intIdtipotaller || !nuevoTaller.datFechataller || !nuevoTaller.strEntidadtaller) {
            Mensaje('Agregar taller', 'Complete todos los campos del taller antes de agregarlo');
            return;
        }
        const talleresActualizados = [
            ...talleresEmpleabilidad,
            {
                id: null,
                intEmpleabilidadid: idEmpleabilidad,
                intIdtipotaller: nuevoTaller.intIdtipotaller,
                datFechataller: nuevoTaller.datFechataller,
                strEntidadtaller: nuevoTaller.strEntidadtaller,
            },
        ];
        setTalleresEmpleabilidad(talleresActualizados);
        setValue('talleresEmpleabilidad', talleresActualizados);
        setNuevoTaller({ id: null, intEmpleabilidadid: idEmpleabilidad, intIdtipotaller: '', datFechataller: null, strEntidadtaller: '' });
    };
    const eliminarTaller = (index) => {
        const talleresActualizados = talleresEmpleabilidad.filter((_, i) => i !== index);
        setTalleresEmpleabilidad(talleresActualizados);
        setValue('talleresEmpleabilidad', talleresActualizados);
    };
    const agregarExperiencia = () => {
        if (!nuevaExperiencia.strExperiencia || !nuevaExperiencia.strTiempoexperiencia) {
            Mensaje('Agregar experiencia', 'Complete todos los campos de la experiencia antes de agregarla');
            return;
        }
        const experienciasActualizadas = [
            ...experienciasEmpleabilidad,
            {
                id: null,
                intEmpleabilidadid: idEmpleabilidad,
                strExperiencia: nuevaExperiencia.strExperiencia,
                strTiempoexperiencia: nuevaExperiencia.strTiempoexperiencia,
            },
        ];
        setExperienciasEmpleabilidad(experienciasActualizadas);
        setValue('experienciasEmpleabilidad', experienciasActualizadas);
        setNuevaExperiencia({ id: null, intEmpleabilidadid: idEmpleabilidad, strExperiencia: '', strTiempoexperiencia: '' });
    };
    const BorrarExperiencia = (index) => {
        const experienciasActualizadas = experienciasEmpleabilidad.filter((_, i) => i !== index);
        setExperienciasEmpleabilidad(experienciasActualizadas);
        setValue('experienciasEmpleabilidad', experienciasActualizadas);
    };
    const agregarSeguimiento = () => {
        if (!nuevoSeguimiento.datFechaseguimiento || !nuevoSeguimiento.intEstadoactualproceso || !nuevoSeguimiento.strObservacionseguimiento) {
            Mensaje('Agregar seguimiento', 'Complete todos los campos del seguimiento antes de agregarlo');
            return;
        }
        const seguimientosActualizados = [
            ...seguimientoEmpleabilidad,
            {
                id: null,
                intEmpleabilidadid: idEmpleabilidad,
                datFechaseguimiento: nuevoSeguimiento.datFechaseguimiento,
                intEstadoactualproceso: nuevoSeguimiento.intEstadoactualproceso,
                strObservacionseguimiento: nuevoSeguimiento.strObservacionseguimiento,
            },
        ];
        setSeguimientoEmpleabilidad(seguimientosActualizados);
        setValue('seguimientoEmpleabilidad', seguimientosActualizados);
        setNuevoSeguimiento({ id: null, intEmpleabilidadid: idEmpleabilidad, datFechaseguimiento: null, intEstadoactualproceso: '', strObservacionseguimiento: '' });
    };
    const eliminarSeguimiento = (index) => {
        const seguimientosActualizados = seguimientoEmpleabilidad.filter((_, i) => i !== index);
        setSeguimientoEmpleabilidad(seguimientosActualizados);
        setValue('seguimientoEmpleabilidad', seguimientosActualizados);
    };
    const agregarRemision = () => {
        if (!nuevoRemision.datFecharemision || !nuevoRemision.strEmpresaremision || !nuevoRemision.strCargoremision || !nuevoRemision.intIdestadoremision) {
            Mensaje('Agregar remisi&oacute;n', 'Complete todos los campos de la remisi&oacute;n antes de agregarla');
            return;
        }
        const remisionesActualizadas = [
            ...remisionLaboralEmpleabilidad,
            {
                id: null,
                intEmpleabilidadid: idEmpleabilidad,
                ...nuevoRemision,
            },
        ];
        setRemisionLaboralEmpleabilidad(remisionesActualizadas);
        setValue('remisionLaboralEmpleabilidad', remisionesActualizadas);
        setNuevoRemision({ id: null, intEmpleabilidadid: idEmpleabilidad, bolRealizaremision: null, datFecharemision: null, strEmpresaremision: '', strCargoremision: '', intIdestadoremision: '' });
    };
    const eliminarRemision = (index) => {
        const remisionesActualizadas = remisionLaboralEmpleabilidad.filter((_, i) => i !== index);
        setRemisionLaboralEmpleabilidad(remisionesActualizadas);
        setValue('remisionLaboralEmpleabilidad', remisionesActualizadas);
    };
    const agregarArticulacion = () => {
        if (!nuevoArticulacion.intRemisionlaboralid || !nuevoArticulacion.datFechaarticulacion || !nuevoArticulacion.strNombreempresaarticulacion || !nuevoArticulacion.strContactoempresaarticulacion || !nuevoArticulacion.strTelefonoempresaarticulacion || !nuevoArticulacion.strCorreoempresaarticulacion) {
            Mensaje('Agregar articulaci&oacute;n', 'Complete todos los campos de la articulaci&oacute;n antes de agregarla');
            return;
        }
        const articulacionesActualizadas = [
            ...articulacionEmpleabilidad,
            {
                id: null,
                intEmpleabilidadid: idEmpleabilidad,
                ...nuevoArticulacion,
            },
        ];
        setArticulacionEmpleabilidad(articulacionesActualizadas);
        setValue('articulacionEmpleabilidad', articulacionesActualizadas);
        setNuevoArticulacion({
            id: null,
            intEmpleabilidadid: idEmpleabilidad,
            intRemisionlaboralid: null,
            datFechaarticulacion: null,
            strNombreempresaarticulacion: '',
            strContactoempresaarticulacion: '',
            strTelefonoempresaarticulacion: '',
            strCorreoempresaarticulacion: '',
        });
    };
    const eliminarArticulacion = (index) => {
        const articulacionesActualizadas = articulacionEmpleabilidad.filter((_, i) => i !== index);
        setArticulacionEmpleabilidad(articulacionesActualizadas);
        setValue('articulacionEmpleabilidad', articulacionesActualizadas);
    };
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    async function ConsultarEmpleabilidad(idEmpleabilidad){ 
        const url = '/reincorporados/consultardatosempleabilidad';
        const obj = { idEmpleabilidad: idEmpleabilidad, userId: user };
        try {
            setCargando(true);
            const response = await apiService.post(url, obj, token);
            const result = await response.data;
            FormReset(result.empleabilidad);
            
            setArrayStateOrError(result.talleresEmpleabilidad, setTalleresEmpleabilidad, 'talleresEmpleabilidad');
            setArrayStateOrError(result.articulacionEmpleabilidad, setArticulacionEmpleabilidad, 'articulacionEmpleabilidad');
            setArrayStateOrError(result.experienciasEmpleabilidad, setExperienciasEmpleabilidad, 'experienciasEmpleabilidad');
            setArrayStateOrError(result.remisionLaboralEmpleabilidad, setRemisionLaboralEmpleabilidad, 'remisionLaboralEmpleabilidad');
            setArrayStateOrError(result.seguimientoEmpleabilidad, setSeguimientoEmpleabilidad, 'seguimientoEmpleabilidad');
            setValue('talleresEmpleabilidad', result.talleresEmpleabilidad);
            setValue('articulacionEmpleabilidad', result.articulacionEmpleabilidad);
            setValue('experienciasEmpleabilidad', result.experienciasEmpleabilidad);
            setValue('remisionLaboralEmpleabilidad', result.remisionLaboralEmpleabilidad);
            setValue('seguimientoEmpleabilidad', result.seguimientoEmpleabilidad);
        } catch (error) {
            console.error('Error fetching empleabilidad data:', error);
        } finally {
            setCargando(false);
        }
    }
    const NuevaEmpleabilidad = () => {
        setTalleresEmpleabilidad([]);
        setArticulacionEmpleabilidad([]);
        setExperienciasEmpleabilidad([]);
        setRemisionLaboralEmpleabilidad([]);
        setSeguimientoEmpleabilidad([]);
        reset({
            ...emptyEmpleabilidadFormValues,
            id: '0',
        });
    };
    return (
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">Empleabilidad</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><NavLink to={'/'} >Inicio</NavLink></li>
                        {idCabezaFamilia !== "0" && <li className="breadcrumb-item"><NavLink to={`/reincorporados/grupofamiliarrei/${idCabezaFamilia}`} >Grupo familiar</NavLink></li>}
                        <li className="breadcrumb-item active"> Empleabilidad</li>
                        </ol>
                    </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                      {Cargando && <div className="centered">
                        <div><progress value={null} /></div>
                      </div>}
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    <MenuReincorporados idCabezaFamilia={idCabezaFamilia} />
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card card-primary">
                                <DatosCabezaFamilia datos={CabezaFamiliaDatos} />
                                <div className='row'>
                                    <div className="col-md-12">
                                        <Accordion>
                                            <AccordionSummary
                                                expandIcon={<ArrowDownwardIcon />}
                                                aria-controls="panel1a-content"
                                                id="panel1a-header"
                                                className="bg-primary text-white"
                                            >
                                                <Typography>Procesos de empleabilidad</Typography>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                                <div className="d-flex justify-content-end mb-3">
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-light"
                                                        onClick={(event) => {
                                                            event.stopPropagation();
                                                            NuevaEmpleabilidad();
                                                        }}
                                                    >
                                                        Nuevo
                                                    </button>
                                                </div>
                                                <div className="card-body table-responsive p-0">
                                                    <table className="table table-bordered table-hover">
                                                        <thead>
                                                        <tr>
                                                            <th>Acciones</th>
                                                            <th>id</th>
                                                            <th>Cargo</th>
                                                            <th>Habilidad</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        {procesosEmpleabilidad.length === 0 ? (
                                                            <tr>
                                                            <td colSpan="4" className="text-center">
                                                                No hay procesos de empleabilidad disponibles
                                                            </td>
                                                            </tr>
                                                        ) : (
                                                            procesosEmpleabilidad.map((row, index) => (
                                                            <tr key={row.id || index}>
                                                                <td>
                                                                    <button 
                                                                        type="button" 
                                                                        className="btn 
                                                                        btn-sm btn-primary"
                                                                        onClick={() => ConsultarEmpleabilidad(row.id)}>Editar</button>
                                                                    <button type="button" className="btn btn-sm btn-danger">Eliminar</button>
                                                          
                                                          
                                                          
                                                                </td>
                                                                <td>{row.id}</td>
                                                                <td>{row.strCargo}</td>
                                                                <td>{row.strHabilidadcompetencia}</td>
                                                            </tr>
                                                            ))
                                                        )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </AccordionDetails>
                                        </Accordion>
                                    </div>
                                </div>
                                <form className="form-horizontal" onSubmit={handleSubmit(onSubmit)}>
                                    {idEmpleabilidad && <div className="card-body">
                                        <input hidden {...register('id')}/>
                                        <input hidden {...register('usrId')}/>
                                        <input hidden {...register('cabIdcabezafamilia')}/>
                                        <div className="card">
                                            <div className="card-header">
                                                <h5 className="card-title m-0">1. Perfil ocupacional</h5>
                                            </div>
                                            <div className="card-body">
                                                <div className="row">
                                                    <div className="col-md-3">
                                                        <label htmlFor="strIdpersona">Integrante</label>
                                                        <select
                                                            id="strIdpersona"
                                                            className="form-control"
                                                            {...register('strIdpersona', { required: true })}
                                                        >
                                                            <option value="">Seleccione...</option>
                                                            {integrantesdto.map((integrante) => (
                                                                <option key={integrante.per_idpersona} value={integrante.per_idpersona}>
                                                                    {integrante.nombre}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        {errors.strIdpersona && <p style={{color: 'red'}}>Seleccione integrante</p>}
                                                    </div>
                                                    <div className="col-md-3">
                                                        <label htmlFor="strCargo">Cargo</label>
                                                        <input
                                                            id="strCargo"
                                                            className="form-control"
                                                            {...register('strCargo', { required: true })}
                                                        />
                                                        {errors.strCargo && <p style={{color: 'red'}}>Seleccione cargo</p>}
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <div className='row'>
                                                            <div className="col-md-12">
                                                                <label htmlFor="strHabilidadcompetencia">Habilidad/Competencia</label>
                                                            </div>
                                                        </div>
                                                        <div className='row'>
                                                            <div className="col-md-12">
                                                            <textarea rows={3} style={{ width: '100%' }}
                                                                {...register('strHabilidadcompetencia', { required: true })}
                                                                placeholder="descripci&oacute;n de la atenci&oacute;n"
                                                            />
                                                            </div>
                                                            {errors.strHabilidadcompetencia && <p style={{color: 'red'}}>Ingrese habilidad/competencia</p>}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className='row'>
                                                            <div className="col-md-12">
                                                                <label htmlFor="strIntereslaboral">Inter&eacute;s Laboral</label>
                                                            </div>
                                                        </div>
                                                        <div className='row'>
                                                            <div className="col-md-12">
                                                            <textarea rows={3} style={{ width: '100%' }}
                                                                {...register('strIntereslaboral', { required: true })}
                                                                placeholder="descripci&oacute;n del inter&eacute;s laboral"
                                                            />
                                                            </div>
                                                            {errors.strIntereslaboral && <p style={{color: 'red'}}>Ingrese inter&eacute;s laboral</p>}
                                                        </div>
                                                    </div>
                                                </div>  
                                            </div>
                                        </div>
                                        <div className="card card-outline card-secondary">
                                            <div className="card-header">
                                                <h6 className="card-title m-0">Experiencias de empleabilidad</h6>
                                            </div>
                                            <div className="card-body">
                                                <div className="row">
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="nuevaExperiencia_strExperiencia">Experiencia</label>
                                                            <input
                                                                type="text"
                                                                id="nuevaExperiencia_strExperiencia"
                                                                className="form-control"
                                                                maxLength={120}
                                                                value={nuevaExperiencia.strExperiencia}
                                                                onChange={(e) => setNuevaExperiencia({ ...nuevaExperiencia, strExperiencia: e.target.value })}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="nuevaExperiencia_strTiempoexperiencia">Tiempo de experiencia</label>
                                                            <input
                                                                type="text"
                                                                id="nuevaExperiencia_strTiempoexperiencia"
                                                                className="form-control"
                                                                maxLength={120}
                                                                value={nuevaExperiencia.strTiempoexperiencia}
                                                                onChange={(e) => setNuevaExperiencia({ ...nuevaExperiencia, strTiempoexperiencia: e.target.value })}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-2 d-flex align-items-end">
                                                        <div className="form-group w-100">
                                                            <button type="button" className="btn btn-primary w-100" onClick={agregarExperiencia}>
                                                                Agregar experiencia
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="table-responsive">
                                                    <table className="table table-bordered table-hover">
                                                        <thead>
                                                            <tr>
                                                                <th>Acciones</th>
                                                                <th>Id</th>
                                                                <th>Experiencia</th>
                                                                <th>Tiempo de experiencia</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {experienciasEmpleabilidad.length === 0 ? (
                                                                <tr><td colSpan="5" className="text-center">No hay experiencias agregadas</td></tr>
                                                            ) : experienciasEmpleabilidad.map((experiencia, index) => {
                                                                return (
                                                                    <tr key={experiencia.id ?? `nueva-experiencia-${index}`}>
                                                                        <td><button type="button" className="btn btn-sm btn-danger" onClick={() => BorrarExperiencia(index)}>Eliminar</button></td>
                                                                        <td>{experiencia.id || ''}</td>
                                                                        <td>{experiencia.strExperiencia}</td>
                                                                        <td>{experiencia.strTiempoexperiencia}</td>
                                                                    </tr>
                                                                );
                                                            })}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card">
                                            <div className="card-body">
                                                <div className="row">
                                                    <div className="col-md-3">
                                                        <label htmlFor="bolTienecertificados">¿Tiene certificados?</label>
                                                        <select
                                                            id="bolTienecertificados"
                                                            className="form-control"
                                                            {...register('bolTienecertificados', { required: true })}
                                                        >
                                                            <option value="">Seleccione...</option>
                                                            <option value="true">SI</option>
                                                            <option value="false">NO</option>
                                                        </select>
                                                        {errors.bolTienecertificados && <p style={{color: 'red'}}>Seleccione si tiene certificados</p>}
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label htmlFor="bolParticipajornadaempleo">¿Participa en jornada de empleo?</label>
                                                            <select
                                                                id="bolParticipajornadaempleo"
                                                                className="form-control"
                                                                {...register('bolParticipajornadaempleo', { required: true })}
                                                            >
                                                                <option value="">Seleccione...</option>
                                                                <option value="true">SI</option>
                                                                <option value="false">NO</option>
                                                            </select>
                                                            {errors.bolParticipajornadaempleo && <p style={{color: 'red'}}>Seleccione si participa en jornada de empleo</p>}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label htmlFor="bolRegistrohojavidaq">¿Registr&oacute; hoja de vida?</label>
                                                            <select
                                                                id="bolRegistrohojavidaq"
                                                                className="form-control"
                                                                {...register('bolRegistrohojavidaq', { required: true })}
                                                            >
                                                                <option value="">Seleccione...</option>
                                                                <option value="true">SI</option>
                                                                <option value="false">NO</option>
                                                            </select>
                                                            {errors.bolRegistrohojavidaq && <p style={{color: 'red'}}>Seleccione si registr&oacute; hoja de vida</p>}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label htmlFor="intIdbolsaempleo">Bolsa de empleo</label>
                                                            <select
                                                                id="intIdbolsaempleo"
                                                                className="form-control"
                                                                {...register('intIdbolsaempleo', { required: true })}
                                                            >
                                                                <option value="">Seleccione...</option>
                                                                {bolsasEmpleo.map((bolsa, index) => (
                                                                    <option key={bolsa.id || index} value={bolsa.id}>
                                                                        {bolsa.strNombre || bolsa.nombre}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                            {errors.intIdbolsaempleo && <p style={{color: 'red'}}>Seleccione bolsa de empleo</p>}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {idEmpleabilidad > 0 && (
                                        <div className="card">
                                            <div className="card-header">
                                                <h5 className="card-title m-0">2. Talleres</h5>
                                            </div>
                                            <div className="card-body">
                                                <div className="row">
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label htmlFor="nuevoTaller_idtipotaller">Tipo de taller</label>
                                                            <select
                                                                id="nuevoTaller_idtipotaller"
                                                                className="form-control"
                                                                value={nuevoTaller.intIdtipotaller}
                                                                onChange={(e) => setNuevoTaller({ ...nuevoTaller, intIdtipotaller: e.target.value })}
                                                            >
                                                                <option value="">Seleccione...</option>
                                                                {tiposTalleres.map((taller, index) => (
                                                                    <option key={taller.id || index} value={taller.id}>
                                                                        {taller.strNombre || taller.nombre}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-2">
                                                        <div className="form-group">
                                                            <label htmlFor="nuevoTaller_fechataller">Fecha taller</label>
                                                            <Controller
                                                                id="nuevoTaller_fechataller"
                                                                control={control}
                                                                name="nuevoTaller_fechataller"
                                                                render={({ field }) => (
                                                                    <DatePicker
                                                                    placeholderText="fecha taller"
                                                                    onChange={(date) => {
                                                                        const fechaFormateada = date
                                                                            ? new Date(date.setHours(12, 0, 0, 0)).toISOString()
                                                                            : null;
                                                                        field.onChange(fechaFormateada);
                                                                        setNuevoTaller({
                                                                            ...nuevoTaller,
                                                                            datFechataller: fechaFormateada,
                                                                        });
                                                                    }}
                                                                    showMonthDropdown
                                                                    showYearDropdown
                                                                    dropdownMode="select"
                                                                    selected={field.value}
                                                                    customInput={<CustomInput />}
                                                                    locale="es"
                                                                    dateFormat="yyyy-MM-dd"
                                                                    maxDate={new Date()}
                                                                    />
                                                                )}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="nuevoTaller_entidadtaller">Entidad taller</label>
                                                            <input
                                                                type="text"
                                                                id="nuevoTaller_entidadtaller"
                                                                maxLength={120}
                                                                className="form-control"
                                                                value={nuevoTaller.strEntidadtaller}
                                                                onChange={(e) => setNuevoTaller({ ...nuevoTaller, strEntidadtaller: e.target.value })}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3 d-flex align-items-end">
                                                        <div className="form-group w-100">
                                                            <button
                                                                type="button"
                                                                className="btn btn-primary w-100"
                                                                onClick={agregarTaller}
                                                            >
                                                                Agregar taller
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-12 table-responsive">
                                                        <table className="table table-bordered table-hover">
                                                            <thead>
                                                                <tr>
                                                                    <th>Acciones</th>
                                                                    <th>Tipo de taller</th>
                                                                    <th>Fecha taller</th>
                                                                    <th>Entidad taller</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {talleresEmpleabilidad.length === 0 ? (
                                                                    <tr>
                                                                        <td colSpan="4" className="text-center">
                                                                            No hay talleres agregados
                                                                        </td>
                                                                    </tr>
                                                                ) : (
                                                                    talleresEmpleabilidad.map((taller, index) => {
                                                                        const tipoTaller = tiposTalleres.find(
                                                                            (t) => String(t.id) === String(taller.intIdtipotaller)
                                                                        );
                                                                        return (
                                                                            <tr key={taller.id ?? `nuevo-${index}`}>
                                                                                <td>
                                                                                    <button
                                                                                        type="button"
                                                                                        className="btn btn-sm btn-danger"
                                                                                        onClick={() => eliminarTaller(index)}
                                                                                    >
                                                                                        Eliminar
                                                                                    </button>
                                                                                </td>
                                                                                <td>{tipoTaller ? (tipoTaller.strNombre || tipoTaller.nombre) : taller.intIdtipotaller}</td>
                                                                                <td>{taller.datFechataller ? taller.datFechataller.slice(0, 10) : taller.datFechataller}</td>
                                                                                <td>{taller.strEntidadtaller}</td>
                                                                            </tr>
                                                                        );
                                                                    })
                                                                )}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>)}
                                        {idEmpleabilidad > 0 && (
                                        <div className="card">
                                            <div className="card-header">
                                                <h5 className="card-title m-0">3. Remisiones laborales</h5>
                                            </div>
                                            <div className="card-body">
                                                <div className="row">
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label htmlFor="nuevoRemision_fecha">Fecha de remisi&oacute;n</label>
                                                            <Controller
                                                                id="nuevoRemision_fecha"
                                                                control={control}
                                                                name="nuevoRemision_fecha"
                                                                render={({ field }) => (
                                                                    <DatePicker
                                                                    placeholderText="fecha remisión"
                                                                    onChange={(date) => {
                                                                        const fechaFormateada = date
                                                                            ? new Date(date.setHours(12, 0, 0, 0)).toISOString()
                                                                            : null;
                                                                        field.onChange(fechaFormateada);
                                                                        setNuevoRemision({ ...nuevoRemision, datFecharemision: fechaFormateada });
                                                                    }}
                                                                    showMonthDropdown
                                                                    showYearDropdown
                                                                    dropdownMode="select"
                                                                    selected={field.value}
                                                                    customInput={<CustomInput />}
                                                                    locale="es"
                                                                    dateFormat="yyyy-MM-dd"
                                                                    maxDate={new Date()}
                                                                    />
                                                                )}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label htmlFor="nuevoRemision_realizada">¿Realiz&oacute; la remisi&oacute;n?</label>
                                                            <select
                                                                id="nuevoRemision_realizada"
                                                                className="form-control"
                                                                value={nuevoRemision.bolRealizaremision === null ? '' : String(nuevoRemision.bolRealizaremision)}
                                                                onChange={(e) => setNuevoRemision({ ...nuevoRemision, bolRealizaremision: e.target.value === '' ? null : e.target.value === 'true' })}
                                                            >
                                                                <option value="">Seleccione...</option>
                                                                <option value="true">SI</option>
                                                                <option value="false">NO</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label htmlFor="nuevoRemision_empresa">Empresa de remisi&oacute;n</label>
                                                            <input
                                                                type="text"
                                                                id="nuevoRemision_empresa"
                                                                className="form-control"
                                                                maxLength="120"
                                                                value={nuevoRemision.strEmpresaremision}
                                                                onChange={(e) => setNuevoRemision({ ...nuevoRemision, strEmpresaremision: e.target.value })}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label htmlFor="nuevoRemision_cargo">Cargo de remisi&oacute;n</label>
                                                            <input
                                                                type="text"
                                                                id="nuevoRemision_cargo"
                                                                className="form-control"
                                                                maxLength="120"
                                                                value={nuevoRemision.strCargoremision}
                                                                onChange={(e) => setNuevoRemision({ ...nuevoRemision, strCargoremision: e.target.value })}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label htmlFor="nuevoRemision_estado">Estado de la remisi&oacute;n</label>
                                                            <select
                                                                id="nuevoRemision_estado"
                                                                className="form-control"
                                                                value={nuevoRemision.intIdestadoremision}
                                                                onChange={(e) => setNuevoRemision({ ...nuevoRemision, intIdestadoremision: e.target.value })}
                                                            >
                                                                <option value="">Seleccione...</option>
                                                                {estadosRemision.map((estado, index) => (
                                                                    <option key={estado.id || index} value={estado.id}>
                                                                        {estado.strNombre || estado.nombre}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3 d-flex align-items-end">
                                                        <div className="form-group w-100">
                                                            <button type="button" className="btn btn-primary w-100" onClick={agregarRemision}>
                                                                Agregar remisi&oacute;n
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-12 table-responsive">
                                                        <table className="table table-bordered table-hover">
                                                            <thead>
                                                                <tr><th>Acciones</th><th>Fecha de remisi&oacute;n</th><th>¿Realiz&oacute; remisi&oacute;n?</th><th>Empresa</th><th>Cargo</th><th>Estado</th></tr>
                                                            </thead>
                                                            <tbody>
                                                                {remisionLaboralEmpleabilidad.length === 0 ? (
                                                                    <tr><td colSpan="6" className="text-center">No hay remisiones agregadas</td></tr>
                                                                ) : remisionLaboralEmpleabilidad.map((remision, index) => {
                                                                    const estadoRemision = estadosRemision.find(
                                                                            (t) => String(t.id) === String(remision.intIdestadoremision)
                                                                        );
                                                                    return (
                                                                        <tr key={remision.id ?? `nuevo-${index}`}>
                                                                            <td><button type="button" className="btn btn-sm btn-danger" onClick={() => eliminarRemision(index)}>Eliminar</button></td>
                                                                            <td>{remision.datFecharemision ? remision.datFecharemision.slice(0, 10) : remision.datFecharemision}</td>
                                                                            <td>{remision.bolRealizaremision === null || remision.bolRealizaremision === undefined ? '' : remision.bolRealizaremision ? 'SI' : 'NO'}</td>
                                                                            <td>{remision.strEmpresaremision}</td>
                                                                            <td>{remision.strCargoremision}</td>
                                                                            <td>{estadoRemision?.nombre ?? remision.intIdestadoremision}</td>
                                                                        </tr>
                                                                    );
                                                                })}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>)}
                                        {idEmpleabilidad > 0 && (
                                        <div className="card">
                                            <div className="card-header">
                                                <h5 className="card-title m-0">4. Seguimiento a la inserci&oacute;n laboral</h5>
                                            </div>
                                            <div className="card-body">
                                                <div className="row">
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label htmlFor="nuevoSeguimiento_fecha">Fecha seguimiento</label>
                                                            <Controller
                                                                id="nuevoSeguimiento_fecha"
                                                                control={control}
                                                                name="nuevoSeguimiento_fecha"
                                                                render={({ field }) => (
                                                                    <DatePicker
                                                                    placeholderText="fecha seguimiento"
                                                                    onChange={(date) => {
                                                                        const fechaFormateada = date
                                                                            ? new Date(date.setHours(12, 0, 0, 0)).toISOString()
                                                                            : null;
                                                                        field.onChange(fechaFormateada);
                                                                        setNuevoSeguimiento({ ...nuevoSeguimiento, datFechaseguimiento: fechaFormateada });
                                                                    }}
                                                                    showMonthDropdown
                                                                    showYearDropdown
                                                                    dropdownMode="select"
                                                                    selected={field.value}
                                                                    customInput={<CustomInput />}
                                                                    locale="es"
                                                                    dateFormat="yyyy-MM-dd"
                                                                    maxDate={new Date()}
                                                                    />
                                                                )}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label htmlFor="nuevoSeguimiento_estado">Estado actual del proceso</label>
                                                            <select
                                                                id="nuevoSeguimiento_estado"
                                                                className="form-control"
                                                                value={nuevoSeguimiento.intEstadoactualproceso}
                                                                onChange={(e) => setNuevoSeguimiento({ ...nuevoSeguimiento, intEstadoactualproceso: e.target.value })}
                                                            >
                                                                <option value="">Seleccione...</option>
                                                                {estadoProcesoEmpleabilidad.map((estado, index) => (
                                                                    <option key={estado.id || index} value={estado.id}>
                                                                        {estado.strNombre || estado.nombre}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="nuevoSeguimiento_observacion">Observaci&oacute;n seguimiento</label>
                                                            <textarea
                                                                id="nuevoSeguimiento_observacion"
                                                                className="form-control"
                                                                rows="1"
                                                                value={nuevoSeguimiento.strObservacionseguimiento}
                                                                onChange={(e) => setNuevoSeguimiento({ ...nuevoSeguimiento, strObservacionseguimiento: e.target.value })}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-2 d-flex align-items-end">
                                                        <div className="form-group w-100">
                                                            <button
                                                                type="button"
                                                                className="btn btn-primary w-100"
                                                                onClick={agregarSeguimiento}
                                                            >
                                                                Agregar seguimiento
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-12 table-responsive">
                                                        <table className="table table-bordered table-hover">
                                                            <thead>
                                                                <tr>
                                                                    <th>Acciones</th>
                                                                    <th>Fecha seguimiento</th>
                                                                    <th>Estado actual del proceso</th>
                                                                    <th>Observaci&oacute;n</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {seguimientoEmpleabilidad.length === 0 ? (
                                                                    <tr>
                                                                        <td colSpan="4" className="text-center">
                                                                            No hay seguimientos agregados
                                                                        </td>
                                                                    </tr>
                                                                ) : (
                                                                    seguimientoEmpleabilidad.map((seguimiento, index) => {
                                                                        const estadoProceso = estadoProcesoEmpleabilidad.find(
                                                                            (t) => String(t.id) === String(seguimiento.intEstadoactualproceso)
                                                                        );
                                                                        return (
                                                                        <tr key={seguimiento.id ?? `nuevo-${index}`}>
                                                                            <td>
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-sm btn-danger"
                                                                                    onClick={() => eliminarSeguimiento(index)}
                                                                                >
                                                                                    Eliminar
                                                                                </button>
                                                                            </td>
                                                                            <td>{seguimiento.datFechaseguimiento ? seguimiento.datFechaseguimiento.slice(0, 10) : seguimiento.datFechaseguimiento}</td>
                                                                            <td>{estadoProceso?.strNombre ?? seguimiento.intEstadoactualproceso}</td>
                                                                            <td>{seguimiento.strObservacionseguimiento}</td>
                                                                        </tr>
                                                                    )})
                                                                )}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>)}
                                        {idEmpleabilidad > 0 && (
                                        <div className="card">
                                            <div className="card-body">
                                                <div className="row">
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label htmlFor="bolLogrovinculacionlaboral">¿Logr&oacute; vinculaci&oacute;n laboral?</label>
                                                            <select
                                                                id="bolLogrovinculacionlaboral"
                                                                className="form-control"
                                                                {...register('bolLogrovinculacionlaboral')}
                                                            >
                                                                <option value="">Seleccione...</option>
                                                                <option value="true">SI</option>
                                                                <option value="false">NO</option>
                                                            </select>
                                                            {errors.bolLogrovinculacionlaboral && <p style={{color: 'red'}}>Seleccione si logr&oacute; vinculaci&oacute;n laboral</p>}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-2">
                                                        <div className="form-group">
                                                            <label htmlFor='datFechavinculacion'>Fecha de vinculacion</label>
                                                            <Controller
                                                                id="datFechavinculacion"
                                                                control={control}
                                                                name="datFechavinculacion"
                                                                render={({ field }) => (
                                                                    <DatePicker
                                                                    placeholderText="fecha de vinculacion"
                                                                    onChange={(date) => {
                                                                        const fechaFormateada = date
                                                                            ? new Date(date.setHours(12, 0, 0, 0)).toISOString()
                                                                            : null;
                                                                        field.onChange(fechaFormateada);
                                                                    }
                                                                    }
                                                                    showMonthDropdown
                                                                    showYearDropdown
                                                                    dropdownMode="select"
                                                                    selected={field.value}
                                                                    customInput={<CustomInput />}
                                                                    locale="es"
                                                                    dateFormat="yyyy-MM-dd"
                                                                    maxDate={new Date()}
                                                                    />
                                                                )}
                                                            />
                                                            {errors.datFechavinculacion && <p style={{color: 'red'}}>Digite fecha de vinculaci&oacute;n</p>}
                                                        </div>
                                                        
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label htmlFor="strEmpresavinculacion">Empresa de vinculaci&oacute;n</label>
                                                            <input
                                                                id="strEmpresavinculacion"
                                                                type="text"
                                                                className="form-control"
                                                                maxLength={120}
                                                                {...register('strEmpresavinculacion')}
                                                            />
                                                            {errors.strEmpresavinculacion && <p style={{color: 'red'}}>Digite empresa de vinculaci&oacute;n</p>}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label htmlFor="strCargovinculacion">Cargo de vinculaci&oacute;n</label>
                                                            <input
                                                                id="strCargovinculacion"
                                                                type="text"
                                                                className="form-control"
                                                                maxLength={120}
                                                                {...register('strCargovinculacion')}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label htmlFor="intIdtipovinculacion">Tipo de vinculaci&oacute;n</label>
                                                            <select
                                                                id="intIdtipovinculacion"
                                                                className="form-control"
                                                                {...register('intIdtipovinculacion')}
                                                            >
                                                                <option value="">Seleccione...</option>
                                                                {tiposVinculacion.map((tipo, index) => (
                                                                    <option key={tipo.id || index} value={tipo.id}>
                                                                        {tipo.strNombre || tipo.nombre}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                            {errors.intIdtipovinculacion && <p style={{color: 'red'}}>Seleccione tipo de vinculaci&oacute;n</p>}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label htmlFor="intIdingresoseconomicos">Ingresos econ&oacute;micos</label>
                                                            <select
                                                                id="intIdingresoseconomicos"
                                                                className="form-control"
                                                                {...register('intIdingresoseconomicos')}
                                                            >
                                                                <option value="">Seleccione...</option>
                                                                {ingresosEconomicos.map((ingreso, index) => (
                                                                    <option key={ingreso.id || index} value={ingreso.id}>
                                                                        {ingreso.strNombre || ingreso.nombre}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                            {errors.intIdingresoseconomicos && <p style={{color: 'red'}}>Seleccione ingresos econ&oacute;micos</p>}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label htmlFor="strObservacion">Observaci&oacute;n</label>
                                                            <textarea
                                                                id="strObservacion"
                                                                className="form-control"
                                                                rows="3"
                                                                {...register('strObservacion')}
                                                            />
                                                            {errors.strObservacion && <p style={{color: 'red'}}>Este campo es obligatorio</p>}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>)}
                                        {idEmpleabilidad > 0 && (
                                        <div className="card">
                                            <div className="card-header">
                                                <h5 className="card-title m-0">5. Articulaciones empleabilidad</h5>
                                            </div>
                                            <div className="card-body">
                                                <div className="row">
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label htmlFor="nuevoArticulacion_remision">Remisi&oacute;n laboral</label>
                                                            <select
                                                                id="nuevoArticulacion_remision"
                                                                className="form-control"
                                                                value={nuevoArticulacion.intRemisionlaboralid ?? ''}
                                                                onChange={(e) => setNuevoArticulacion({ ...nuevoArticulacion, intRemisionlaboralid: e.target.value })}
                                                            >
                                                                <option value="">Seleccione...</option>
                                                                {remisionLaboralEmpleabilidad.map((remision, index) => (
                                                                    <option key={remision.intRemisionlaboralid ?? remision.id ?? index} value={remision.intRemisionlaboralid ?? remision.id}>
                                                                        {remision.strEmpresaremision || `Remisi&oacute;n ${index + 1}`}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label htmlFor="nuevoArticulacion_fecha">Fecha articulaci&oacute;n</label>
                                                            <Controller
                                                                id="nuevoArticulacion_fecha"
                                                                control={control}
                                                                name="nuevoArticulacion_fecha"
                                                                render={({ field }) => (
                                                                    <DatePicker
                                                                    placeholderText="fecha articulación"
                                                                    onChange={(date) => {
                                                                        const fechaFormateada = date
                                                                            ? new Date(date.setHours(12, 0, 0, 0)).toISOString()
                                                                            : null;
                                                                        field.onChange(fechaFormateada);
                                                                        setNuevoArticulacion({ ...nuevoArticulacion, datFechaarticulacion: fechaFormateada });
                                                                    }}
                                                                    showMonthDropdown
                                                                    showYearDropdown
                                                                    dropdownMode="select"
                                                                    selected={field.value}
                                                                    customInput={<CustomInput />}
                                                                    locale="es"
                                                                    dateFormat="yyyy-MM-dd"
                                                                    maxDate={new Date()}
                                                                    />
                                                                )}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label htmlFor="nuevoArticulacion_empresa">Nombre empresa</label>
                                                            <input 
                                                                type="text" 
                                                                id="nuevoArticulacion_empresa" 
                                                                className="form-control" 
                                                                maxLength={120} 
                                                                value={nuevoArticulacion.strNombreempresaarticulacion} 
                                                                onChange={(e) => setNuevoArticulacion({ ...nuevoArticulacion, strNombreempresaarticulacion: e.target.value })} />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label htmlFor="nuevoArticulacion_contacto">Contacto empresa</label>
                                                            <input 
                                                                type="text" 
                                                                id="nuevoArticulacion_contacto" 
                                                                className="form-control" 
                                                                maxLength={120} 
                                                                value={nuevoArticulacion.strContactoempresaarticulacion} 
                                                                onChange={(e) => setNuevoArticulacion({ ...nuevoArticulacion, strContactoempresaarticulacion: e.target.value })} />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label htmlFor="nuevoArticulacion_telefono">Teléfono empresa</label>
                                                            <input 
                                                                type="text" 
                                                                id="nuevoArticulacion_telefono" 
                                                                className="form-control" 
                                                                maxLength={90} 
                                                                value={nuevoArticulacion.strTelefonoempresaarticulacion} 
                                                                onChange={(e) => setNuevoArticulacion({ ...nuevoArticulacion, strTelefonoempresaarticulacion: e.target.value })} />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="form-group">
                                                            <label htmlFor="nuevoArticulacion_correo">Correo empresa</label>
                                                            <input 
                                                                type="email" 
                                                                id="nuevoArticulacion_correo" 
                                                                className="form-control" 
                                                                maxLength={90} 
                                                                value={nuevoArticulacion.strCorreoempresaarticulacion} 
                                                                onChange={(e) => setNuevoArticulacion({ ...nuevoArticulacion, strCorreoempresaarticulacion: e.target.value })} />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-2 d-flex align-items-end"><div className="form-group w-100"><button type="button" className="btn btn-primary w-100" onClick={agregarArticulacion}>Agregar articulaci&oacute;n</button></div></div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-12 table-responsive">
                                                        <table className="table table-bordered table-hover">
                                                            <thead>
                                                                <tr>
                                                                    <th>Acciones</th><th>Remisi&oacute;n</th><th>Fecha articulaci&oacute;n</th><th>Nombre empresa</th><th>Contacto empresa</th><th>Teléfono empresa</th><th>Correo empresa</th>
                                                                    </tr>
                                                            </thead>
                                                            <tbody>
                                                                {articulacionEmpleabilidad.length === 0 ? 
                                                                    <tr>
                                                                        <td colSpan="7" className="text-center">No hay articulaciones agregadas</td>
                                                                    </tr> 
                                                                    : 
                                                                articulacionEmpleabilidad.map((articulacion, index) => {
                                                                    const remisionLabel = remisionLaboralEmpleabilidad.find((r) => String(r.id) === String(articulacion.intRemisionlaboralid))?.strEmpresaremision || articulacion.intRemisionlaboralid;
                                                                    return (
                                                                    <tr key={articulacion.id ?? `nuevo-${index}`}>
                                                                        <td>
                                                                            <button 
                                                                                type="button" 
                                                                                className="btn btn-sm btn-danger" 
                                                                                onClick={() => eliminarArticulacion(index)}>Eliminar
                                                                            </button>
                                                                        </td>
                                                                        <td>{remisionLabel ?? articulacion.intRemisionlaboralid}</td>
                                                                        <td>{articulacion.datFechaarticulacion ? articulacion.datFechaarticulacion.slice(0, 10) : articulacion.datFechaarticulacion}</td>
                                                                        <td>{articulacion.strNombreempresaarticulacion}</td>
                                                                        <td>{articulacion.strContactoempresaarticulacion}</td>
                                                                        <td>{articulacion.strTelefonoempresaarticulacion}</td>
                                                                        <td>{articulacion.strCorreoempresaarticulacion}</td>
                                                                    </tr>
                                                                )})}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>)}
                                    </div>}
                                    {idEmpleabilidad && <div className="card-footer">
                                        <button type="submit" className="btn btn-primary">Guardar</button>
                                    </div>}
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
                <Tooltip id="tooltiparriba" effect="solid" className="custom-tooltip" place="bottom"/>
            </section>
        </div>
    );
}